// Test IDs for the Shadows of the Infinite landing page.
// Naming: keys camelCase, values kebab-case `<feature>-<element>`.

export const HOME = {
  emergentLink: 'home-emergent-link',
};

export const NAV = {
  root: 'site-nav',
  brand: 'nav-brand',
  linkArchive: 'nav-link-archive',
  linkPremise: 'nav-link-premise',
  linkCreator: 'nav-link-creator',
  linkContact: 'nav-link-contact',
  ctaArchive: 'nav-cta-archive',
};

export const HERO = {
  section: 'hero-section',
  overline: 'hero-overline',
  headline: 'hero-headline',
  subheadline: 'hero-subheadline',
  pitch: 'hero-pitch',
  ctaPrimary: 'hero-primary-cta',
  ctaSecondary: 'hero-secondary-cta',
};

export const ARCHIVE = {
  section: 'cinder-archive-section',
  heading: 'archive-heading',
  body: 'archive-body',
  cta: 'archive-cta',
  safety: 'archive-safety',
};

export const PREMISE = {
  section: 'book-premise-section',
  heading: 'premise-heading',
  intro: 'premise-intro',
  body: 'premise-body',
};

export const CREATOR = {
  section: 'about-creator-section',
  heading: 'creator-heading',
  body: 'creator-body',
};

export const COVER = {
  section: 'cover-status-section',
  heading: 'cover-heading',
  body: 'cover-body',
  vitrine: 'cover-vitrine',
};

export const INQUIRIES = {
  section: 'professional-inquiries-section',
  heading: 'inquiries-heading',
  body: 'inquiries-body',
  email: 'inquiries-email',
};

export const FOOTER = {
  root: 'site-footer',
  copy: 'footer-copy',
  linkArchive: 'footer-link-archive',
  linkContact: 'footer-link-contact',
  linkPrivacy: 'footer-link-privacy',
  linkTerms: 'footer-link-terms',
};
